// extracted by mini-css-extract-plugin
export var Section = "Development-module--Section--QtwBQ";
export var LangHY = "Development-module--LangHY--yE-36";
export var Text = "Development-module--Text--W7PYA";
export var Inner = "Development-module--Inner--2IqRt";
export var Column = "Development-module--Column--OB0jh";
export var Mark = "Development-module--Mark--9buzP";
export var Dash = "Development-module--Dash--yzyVX";
export var MarkText = "Development-module--MarkText--CKBCe";
export var Block = "Development-module--Block--4hdmY";
export var arrowLeft = "Development-module--arrowLeft--+3BI-";
export var arrowRight = "Development-module--arrowRight--KmMrK";